import { useEffect } from 'react';
import { usePaymentIntegration } from '../../../../store/payment-integration';
import './styles.scss';
import { WooCard } from '../integration-woo';
import { MagentoCard } from '../integration-magento';
import { ShopifyCard } from '../integration-shopify';
import { PrestashopCard } from '../integration-prestashop';
import { HostingerCard } from '../integration-hostinger';

export const IntegrationCards = () => {
  const { getIntegrationKeys, apiKey } = usePaymentIntegration();

  useEffect(() => {
    if (apiKey.length === 0) {
      getIntegrationKeys();
    }
  }, []);

  return (
    <div className="integration_cards">
      <div className="row">
        <ShopifyCard />
        <HostingerCard />
        <WooCard />
      </div>
      <div className="row">
        <MagentoCard />
        <PrestashopCard />
        <div style={{ flex: 1 }}></div>
      </div>
    </div>
  );
};
